export class SlotBookingModel {
    SlotTime: string;
    SlotStatusValue: string;
    SessionCode: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/SlotBookingModel.ts